const TempLogger = {
    extend: () => TempLogger,
    setContextValue: () => { },
    removeContextValue: () => { },
    trace: (...args) => {
        console.warn('[sdk-chime-video] logger called before configureChimeVideo()');
        console.trace(...args);
    },
    isTrace: () => true,
    debug: (...args) => {
        console.warn('[sdk-chime-video] logger called before configureChimeVideo()');
        console.debug(...args);
    },
    isDebug: () => true,
    info: (...args) => {
        console.warn('[sdk-chime-video] logger called before configureChimeVideo()');
        console.info(...args);
    },
    isInfo: () => true,
    warn: (...args) => {
        console.warn('[sdk-chime-video] logger called before configureChimeVideo()');
        console.warn(...args);
    },
    isWarn: () => true,
    error: (...args) => {
        console.warn('[sdk-chime-video] logger called before configureChimeVideo()');
        console.error(...args);
    },
    isError: () => true,
};
export let streemLogger = TempLogger;
export function setStreemLogger(nextLogger) {
    streemLogger = nextLogger;
}
export function createStreemLogger(context) {
    if (typeof context === 'undefined') {
        return streemLogger;
    }
    return streemLogger.extend(context);
}
//# sourceMappingURL=streem_logger.js.map